import { FontWeight, Heading } from '@lili/lili-frontend-common';
export interface CustomRadioButtonProps {
  checked: boolean;
  onChange: (val: string) => void;
  name: string;
  value: string;
  label: string;
  inputId?: string;
}
export const CustomRadioButton = ({
  checked,
  onChange,
  label,
  name,
  value,
  inputId,
}: CustomRadioButtonProps) => {
  return (
    <label className='flex items-center cursor-pointer gap-2'>
      <div className='relative'>
        {/* Hidden native radio button for accessibility */}
        <input
          data-testid={inputId}
          type='radio'
          className='sr-only hover:border hover:border-surface-brand-action-03'
          checked={checked}
          onChange={() => onChange(value)}
          name={name}
          value={value}
        />

        {/* Custom radio button appearance */}
        <div
          id={inputId ?? value}
          onClick={() => onChange(value)}
          className={`w-[18px] h-[18px] rounded-full border flex items-center justify-center hover:border-surface-brand-action-03 ${checked ? 'border-surface-brand-action-03 bg-surface-primary-bw-00' : 'border-outline-primary-bw-06'}`}>
          {checked && <div className='w-3 h-3 rounded-full bg-surface-brand-action-03'></div>}
        </div>
      </div>

      {/* Label text if provided */}
      {label && <Heading.H9 fontWeight={FontWeight.MEDIUM}>{label}</Heading.H9>}
    </label>
  );
};
